import React from "react";
import { Reveal } from "@/components/anim";
import { TECHNOLOGIES } from "@/data/content";

export default function BrackishPlatform() {
  return (
    <section data-testid="technologies-section" className="bg-bg-primary py-28 md:py-40">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal>
          <p className="text-brand-teal text-xs font-bold uppercase tracking-[0.25em] mb-4">Seawater + Brackish</p>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
            <h2 className="font-heading text-4xl md:text-6xl font-medium tracking-tight text-ink leading-none max-w-3xl">
              Two technologies. One platform.
            </h2>
            <p className="text-ink-soft max-w-md text-base leading-relaxed">
              US Desalination creates value across both seawater and brackish developments — matching the right
              technology to each market to maximize reliability, economics, and speed to water.
            </p>
          </div>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-px bg-brand-navy/15 border border-brand-navy/15">
          {TECHNOLOGIES.map((t, i) => (
            <Reveal key={t.tag} delay={i * 0.1} className="bg-white">
              <div className="group h-full p-8 md:p-12 flex flex-col hover:bg-brand-navy transition-colors duration-300">
                <div className="flex items-center gap-3">
                  <span className="inline-flex items-center px-3 py-1 border border-brand-navy/30 text-brand-navy text-xs font-bold uppercase tracking-[0.2em] group-hover:border-brand-teal group-hover:text-brand-teal transition-colors">
                    {t.tag}
                  </span>
                </div>
                <h3 className="mt-6 font-heading font-extrabold uppercase tracking-tight text-ink text-3xl md:text-4xl leading-none group-hover:text-white transition-colors">
                  {t.name}
                </h3>
                <p className="mt-3 font-accent italic text-lg text-brand-navy group-hover:text-brand-teal transition-colors">
                  {t.lead}
                </p>
                <p className="mt-5 text-ink-soft text-base md:text-lg leading-relaxed group-hover:text-white/70 transition-colors">
                  {t.desc}
                </p>

                <div className="mt-auto pt-10 space-y-3">
                  {t.facts.map((f, j) => (
                    <div
                      key={j}
                      className="flex items-baseline justify-between gap-4 border-t border-brand-navy/10 pt-3 group-hover:border-white/15"
                    >
                      <span className="text-ink-soft text-xs uppercase tracking-[0.15em] group-hover:text-white/50 transition-colors">
                        {f.label}
                      </span>
                      <span className="text-brand-navy font-semibold text-right group-hover:text-brand-teal transition-colors">
                        {f.value}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-10 text-ink-soft text-base md:text-lg leading-relaxed max-w-3xl">
            Together, SWRO and brackish desalination let us deliver <span className="text-brand-navy font-semibold">the
            right supply, at the right scale, for every community we serve</span> — from high-volume coastal utilities to
            fast-growing inland towns.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
